// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"c239cb86","157":"a2a5de0d","267":"ac2a4e74","283":"fc93ff2d","421":"675e30e5","455":"52b2c48e","465":"3d0df77c","500":"e29100cc","688":"d0cc2b23","776":"bf10ddc9"}[chunkId] + ".chunk.js";
};